import React, { Component } from "react";
import { withStyles, styled } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { Grid, TextField, Snackbar } from "@material-ui/core";
import Modal from "@mui/material/Modal";
import MuiAlert from "@mui/material/Alert";
import { MenuUnfoldOutlined, MenuFoldOutlined } from '@ant-design/icons'
import { Input, Button, Table, message, Tooltip, Modal as AntdModal, } from 'antd';
import { withRouter } from "react-router-dom";
import { Tour } from 'antd-v5'
const { confirm } = AntdModal;
import FileCard from "../common/FileCard";
import LabelModal from "../common/LabelModal";
import {
  getUserFileLabel,
  getUserInfo,
  editUserInfo,
  getCollectList,
  getSpecialCollectList,
  delelteFileLabel,
  addLabelToFile,
  addCollectLabel,
  deleteCollectLabel,
  cancelCollectFile,
  deleteCollectFileLabel,
  deleteLabelId,
  getDefaultLabelFileList,
  editLabel,
  exportFavoriteFile,
} from "../../actions/subscribe";
import InfiniteScroll from "react-infinite-scroll-component";

import {
  getLabelId,
  getUserCollectLabelId,
  getCollectId,
  getUserFileLabelList,
  getFileLabelId,
} from "../../utils/common";
import store from "../../store";
import axios from "axios";

const styles = () => {
  return {
    root: {
      width: "100%",
      height: "100%",
      padding: "10px",
      display: 'flex',
      flexDirection: 'column',
      boxSizing: "border-box"
    },
    topBar: {
      width: "100%",
      padding: "10px 20px",
      marginBottom: "10px",
      background: "#FFFFFF",
      boxShadow: "0px 1px 5px 1px rgba(0, 0, 0, 0.1)",
      borderRadius: "5px",
      fontSize: '16px',
      color: '#333'
    },
    main: {
      flex: 1,
      width: "100%",
      height: "1px",
      display: 'flex',
      overflow: 'hidden'
    },
    leftTable: {
      flex: 1,
      width: '1px',
      height: "100%",
      backgroundColor: "#fff",
      boxShadow: "0px 1px 5px 1px rgba(0, 0, 0, 0.1)",
      borderRadius: "5px",
      overflow: 'auto'
    },
    rightForm: {
      position: 'relative',
      width: "300px",
      height: "100%",
      marginLeft: "10px",
      backgroundColor: "#fff",
      boxShadow: "0px 1px 5px 1px rgba(0, 0, 0, 0.1)",
      borderRadius: "5px",
      transition: 'all linear .3s',
    },
    hideSearch: {
      width: 0,
      marginLeft: "0px",
      transition: 'all linear .3s'
    },
    tableOuter: {
      padding: '0 !important',
      margin: '0 !important'
    },
    topTab: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '0 20px'
    },
    line: {
      height: "25px",
      fontSize: "14px",
      color: "#000",
      display: "flex",
      alignItems: "center",
    },
    title: {
      marginRight: "10px",
      fontSize: "18px",
      fontWeight: "bold",
      color: "#5F6876",
    },
    total: {
      color: "#F04C35",
    },
    inputGroup: {
      marginTop: "12px",
    },
    input: {
      width: "535px",
      height: "40px",
      borderRadius: "0",
      marginRight: "20px",
      "& fieldset": {
        borderWidth: "1px !important",
      },
      "& .MuiInputBase-root": {
        borderRadius: "0",
      },
    },
    btn: {
      width: "70px",
      height: "40px",
      background: "#0F25D1 !important",
      borderRadius: "2px !important",
    },
    container: {
      padding: "16px 18px 20px 24px",
    },
    list: {
      width: "1px",
      paddingRight: "16px",
    },
    label: {
      marginBottom: "16px",
    },
    labelContainer: {
      marginTop: "40px"
    },
    btnLine: {
      display: "flex",
      justifyContent: "space-between",
    },
    titleLeft: {
      display: "flex",
      alignItems: "center",
      color: "#42BD57",
      fontSize: "18px",
      fontWeight: "bold",
      "& img": {
        width: "21px",
        height: "21px",
        marginRight: "10px",
      },
      "& button": {
        marginLeft: "20px",
        width: "82px",
        height: "32px",
        padding: "0 10px",
        borderRadius: "0",
        borderColor: "#D9D9D9",
        color: "#000",
        fontSize: "14px",
      },
    },
    subTitle: {
      margin: "20px 0 16px",
      lineHeight: "22px",
      fontSize: "16px",
      color: "#4A4A4A",
      fontWeight: "bold",
    },
    tag: {
      height: "22px",
      margin: "0 10px 16px 0",
      lineHeight: "22px",
      fontSize: "14px",
      color: "#000",
      fontWeight: "400",
      padding: "0 12px",
      display: "inline-block",
      border: "1px solid #E9E9E9",
      borderRadius: "4px",
      cursor: "pointer",
      "&.active": {
        color: "#0F25D1",
        borderColor: "#0F25D1",
      },
    },
    textBtn: {
      color: '#444',
      padding: '0 5px',
      "&:hover": {
        color: '#1890ff !important'
      }
    },
    tabTop: {
      height: "20px"
    },
    linkText: {
      color: '#333',
      '&:hover': {
        color: '#333',
        textDecoration: 'underline'
      }
    },
    slideIcon: {
      cursor: 'pointer',
    },
  };
};

class Collect extends Component {
  constructor(props) {
    super(props);
    this.ref2 = React.createRef(null);
    this.ref3 = React.createRef(null);
    this.ref4 = React.createRef(null);
    this.ref5 = React.createRef(null);
  }

  state = {
    tourKey: 0,
    tourCurrent: 0,
    openTour: false,
    beginner_index: 0,
    keyword: "",
    error: "",
    search_filters: {},
    page: 1,
    is_all: 0,
    count: 0,
    userId: "", //用户id
    username: "", //用户名
    emptyCount: 0,
    openMessage: "",
    errorMessage: "",
    dataId: "", //弹框数据id,点击右侧管理收藏按钮时，传空
    favorite_parent_lable_id: "",
    push: true,
    openModal: false,
    isEdit: false,
    modalTitle: "",
    fileTotal: 0,
    allFileList: [],
    fileList: [],
    labelList: [],
    allLabelList: [], //包含全部和无标签
    tagList: [],
    collectFileId: [],
    collectLabelId: [],
    labelArr: "", // 选中标签
    columns: [],
    loading: false,
    showTab: false,
    data: [],
    tabIndex: 0,
    fileType: "",
    showSearch: true,
    tabList: [
      {
        title: '法律法规',
        type: '法律法规'
      },
      {
        title: '法规',
        type: '法规'
      },
      {
        title: '标准',
        type: '标准'
      },
      {
        title: '指导原则',
        type: '指导原则'
      },
    ],
    form: {

    },
    paginationObj: {
      showSizeChanger: true,
      total: 0,
      showTotal: (total, range) => {
        return '共【' + this.state.paginationObj.total + '】条'
      },
      onChange: (page, pageSize) => {
        this.pageChange(page, pageSize)
      },
    },
    scrollObj: {}
  };

  componentDidMount() {  
    let pathname = this.props.location.pathname;
    let fileType = "";
    let favorite_parent_lable_id = ""
    let showTab = false
    switch (pathname) {
      case "/userCenter/collectLaw":
        fileType = "法律法规";
        favorite_parent_lable_id = 1
        showTab = true
        break;
      case "/userCenter/collectFDA":
        fileType = "海外法规";
        favorite_parent_lable_id = 2
        showTab = false
        break;
    }
    this.setState(
      {
        username: store.getState().auth.username,
        fileType: fileType,
        showTab: showTab,
        favorite_parent_lable_id: favorite_parent_lable_id
      },
      () => {
        this.getColumns()
        this.loadMore();
        this.queryUserInfo()
      }
    );
  }

  //查询用户信息
  queryUserInfo = () => {
    getUserInfo({ username: this.state.username }).then((res) => {
      if (res.results && res.results.length > 0) {
        let userData = res.results[0];
        if (userData) {
          let index = userData.beginner_index
          let openTour = index != 3 && index != 7
          this.setState(
            {
              userId: userData.id,
              openTour: openTour,
              beginner_index: index
            },
          );
        }
      }
    });
  };

  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };
  handlePreview = (url) => {
    const w = window.open("ablut:blank");
    localStorage.setItem("file_url", url);
    w.location.href = "/viewer";
  };
  handCancelCollect = (id) => {
    confirm({
      title: '确认',
      content: '确认取消收藏？',
      onOk: () => {
        getCollectId(id, this.state.userId).then((collectId) => {
          cancelCollectFile(collectId).then((res) => {
            if (res && res.message) {
              message.warning(res.message)
            } else {
              message.success('取消成功')
              this.loadMore();
            }
          });
        });
      }
    })
   
  };
  handSetting = (id) => {
    getUserFileLabelList(id, this.state.userId).then((list) => {
      this.setState({
        openModal: true,
        isEdit: false,
        dataId: id,
        modalTitle: "管理标签",
        tagList: list,
      });
    });
  };

  initEmptyCount = () => {
    const param = {
      medical_file_ids: "[" + this.state.collectFileId.join() + "]",
      lable_ids: "[" + this.state.collectLabelId.join() + "]",
    };
    getSpecialCollectList(param).then((res) => {
      this.setState({
        emptyCount: res.untagged_medical_files.length,
      });
    });
  };

  loadMore = () => {
    let labelId = this.state.labelArr == 'all' ? '' : this.state.labelArr
    const param = {
      username: this.state.username,
      favorite_parent_lable_id: this.state.favorite_parent_lable_id,
      favorite_type_child: this.state.tabIndex ? this.state.tabIndex : 0,
      lable_id: labelId,
      file_name: this.state.form.keyword,
      ...this.state.page
    };
    this.setState({
      loading: true
    })
    getCollectList(param).then((res) => {
      if (res && res.results) {
        let data = res.results
        let newPaginationObj = this.state.paginationObj
        newPaginationObj.total = res.count
        let allCount = labelId ? this.state.fileTotal : res.count
        this.setState({
          data: data,
          paginationObj: newPaginationObj,
          fileTotal: allCount,
          labelList: res.favorite_lables,
          allLabelList: [{ lable_content: "全部", lable_id: "all" }]
          .concat(res.favorite_lables),
          loading: false
        });
      } else {
        this.setState({
          loading: false
        })
      }
    });
  };

  searchFile = () => {
    this.setState(
      {
        page: 1,
      },
      () => this.loadMore(true)
    );
  };

  changePush = () => {
    this.setState({
      push: !this.state.push,
    });
  };

  handleClose = () => {
    this.setState({
      openModal: false,
    });
  };
  showModal = () => {
    this.setState({
      openModal: true,
      isEdit: true,
      modalTitle: "管理收藏",
      dataId: "",
      tagList: [].concat(this.state.labelList),
    });
  };
  //删除标签
  handRemove = (id) => {
    getUserCollectLabelId(this.state.userId, id).then(
      ({ id, labelId, userId }) => {
        deleteCollectLabel(id).then(() => {
          this.setState({ labelArr: "" }, () => this.loadMore());
        });
        //如果是本人现在标签，彻底删除标签
        if (userId == this.state.userId) {
          deleteLabelId(labelId);
        }
        
      }
    );
    let tagList = [].concat(this.state.labelList);
    let index = tagList.findIndex((v) => {
      return v.lable_id === id;
    });
    if (index > -1) {
      tagList.splice(index, 1);
    }
    this.setState({
      tagList: [].concat(tagList),
    });
    //删除文件标签
    deleteCollectFileLabel({
      lable_id: id,
    });
  };
  //新增标签
  handAdd = (tag) => {
    //检查是否已存在
    let index = this.state.tagList.findIndex((v) => {
      return v.lable_content == tag;
    });
    if (index > -1) {
      this.setState({
        openMessage: true,
        errorMessage: "该标签已存在",
      });
      setTimeout(() => {
        this.closeMessage();
      }, 3000);
      return;
    }
    getLabelId(tag, this.state.userId).then((labelId) => {
      if (this.state.modalTitle == "管理收藏") {
        //添加收藏标签
        addCollectLabel({
          lable: labelId,
          user: this.state.userId,
          parent_lable_id: this.state.favorite_parent_lable_id
        }).then((res) => {
          if (res.id) {
            this.setState(
              {
                tagList: this.state.tagList.concat([
                  {
                    lable_content: tag,
                    lable_id: labelId,
                  },
                ]),
              }, () => {
                this.loadMore()
              }
            );
          }
        });
      } else {
        //打标签
        addLabelToFile({
          base_file: this.state.dataId,
          lable: labelId,
          lable_update_user: this.state.userId,
        }).then((resp) => {
          if (resp.id) {
            this.setState({
              tagList: this.state.tagList.concat([
                {
                  lable_content: tag,
                  lable_id: labelId,
                },
              ]),
            });
          }
        });
        //收藏标签
        if (this.state.collectLabelId.includes(labelId) == false) {
          addCollectLabel({
            lable: labelId,
            user: this.state.userId,
          });
        }
        this.setState({ tagArr: labelId });
      }
    });
  };

  //关闭消息弹框
  closeMessage = () => {
    this.setState({
      openMessage: false,
    });
  };

  //选择收藏标签
  changeLabel = (tagId) => {
    let newId = "";
    if (this.state.labelArr != tagId) {
      newId = tagId;
    }
    this.setState(
      {
        labelArr: newId,
      },
      () => this.loadMore()
    );
  };


  downloadFile = ()=>{
    this.state.data.forEach((v) => {
      let url = v.dfs_url;
      if (url) {
        let fileName = v.file_name;
        this.downloadSingleFile(url, fileName);
      }
    });
  }

  downloadSingleFile = (url, fileName) => {
    axios({
      method: "get",
      url: url,
      responseType: "blob",
    }).then((resp) => {
      if (resp.status === 200) {
        if (window.navigator.msSaveOrOpenBlob) {
          let blob = resp.data;
          navigator.msSaveBlob(blob, fileName);
        } else {
          let blob = new Blob([resp.data], { type: "text" });
          let a = document.createElement("a");
          a.download = fileName;
          let URL = window.URL || window.webkitURL;
          a.href = URL.createObjectURL(blob);
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }
      }
    });
  };

  download = ()=>{
    exportFavoriteFile().then((res) => {
      let dateOrigin = new Date();
      let dateString =
        dateOrigin.getFullYear() +
        "-" +
        (dateOrigin.getMonth() + 1) +
        "-" +
        dateOrigin.getDate() +
        "-" +
        dateOrigin.getHours() +
        "-" +
        dateOrigin.getMinutes() +
        "-" +
        dateOrigin.getSeconds();
      let fileName = "DCA收藏信息" + dateString + ".xlsx";
      const blob = new Blob([res], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      let a = document.createElement("a");
      a.download = fileName;
      let URL = window.URL || window.webkitURL;
      a.href = URL.createObjectURL(blob);
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    });
  }

  
  resetForm = () => {
    this.setState({
      form: {
        keyword: ''
      }
    })
  }

  searchForm = () => {
    this.loadMore()
  }

  onChangeForm = (value, key) => {
    let form = {
      ...this.state.form
    }
    form[key] = value
    this.setState({
      form: form
    })
  }

  changeTab = (data, i) => {
    this.setState(
      {
        fileType: data.type,
        tabIndex: i,
      },
      () => {
        this.getColumns()
        this.loadMore();
      }
    );
  }

  getColumns = () => {
    let list = [
      {
        title: '操作',
        dataIndex: 'action',
        key: 'action',
        width: 210,
        align: 'center',
        render: (text, row) => {
          return (
            <>
              {/* <Button type="text" className={this.props.classes.textBtn}>翻译</Button> */}
              <Button type="text" className={this.props.classes.textBtn} onClick={() => this.handCancelCollect(row.base_file)}>
                取消收藏
              </Button>
              <Button className={this.props.classes.textBtn} type="text" onClick={() => this.downloadSingleFile(row.dfs_url, row.file_name)}>下载</Button>
            </>
          )
        }
      },
      {
        title: '文件类型',
        dataIndex: 'file_category',
        key: 'file_category',
        width: 100,
        render: (text, row) => row.file_category
      },
      {
        title: '文件名称',
        dataIndex: 'file_name',
        key: 'file_name',
        width: 200,
        ellipsis: true,
        render: (_, row) => {
          let content = row.file_name || ''
          return   <Tooltip placement="topLeft" title={content}>
            <a target="_blank" className={this.props.classes.linkText} href={row.dfs_url}>{content}</a>
          </Tooltip>
        },
      },
      {
        title: '发布机构',
        dataIndex: 'medical_file_publish_orgnization',
        key: 'medical_file_publish_orgnization',
        width: 140,
      },
      {
        title: '发布时间',
        dataIndex: 'medical_file_publish_date',
        key: 'medical_file_publish_date',
        width: 110,
        render: (text, row) => {
          let data = row.medical_file_publish_date || ''
          return data.substring(0, 10)
        }
      },
      {
        title: '立法阶段',
        dataIndex: 'medical_file_law_status',
        key: 'medical_file_law_status',
        width: 100,
      },
  
      {
        title: '网页链接',
        dataIndex: 'medical_file_website_link',
        key: 'medical_file_website_link',
        width: 200,
        ellipsis: true,
        render: (_, row) => {
          let content = row.medical_file_website_link || ''
          return   <Tooltip placement="topLeft" title={content}>
            <a target="_blank" href={row.medical_file_website_link}>{content}</a>
          </Tooltip>
        },
      },
    ]
    this.setState({
      columns: list
    })
  }

  pageChange = (page, pageSize) => {
    if (page == this.state.page.page && pageSize == this.state.page.pageSize) {
      return
    }
    this.setState({
      page: {
        page: page,
        pageSize: pageSize
      },
      loading: true
    }, () => this.loadMore())
  }

  handleChange = (pagination, filters, sorter) => {
    this.setState(
      {
        loading: true,
      },
      () => {
        this.loadMore();
      }
    );
  };

  changeSearchShow = () => {
    this.setState({
      showSearch: !this.state.showSearch,
      tourKey: this.state.tourKey + 1
    }, () => {
      setTimeout(() => {
        this.setState({
          tourKey: this.state.tourKey + 1
        })
      }, 350)
    })
  }

  changeTour = (current) => {
    this.setState({
      tourCurrent: current
    })
  }

  
  closeTour = () => {
    this.setState({
      openTour: false
    })
    // 更新新手指引状态
    editUserInfo({
      beginner_index: this.state.beginner_index + 2
    })
  }

  render() {
    const classes = this.props.classes;

    const steps = [
      {
        title: '',
        description: '收藏夹中包含您收藏过的法规',
        target: () => document.getElementById('my-collect'),
        placement: 'right'
      },
      {
        title: '',
        description: '点击可编辑、新增或删除收藏关键词',
        target: () => this.ref2.current,
        placement: 'left'
      },
      {
        title: '',
        description: '可下载当前列表中文件的基础信息',
        target: () => this.ref3.current,
        placement: 'left'
      },
      {
        title: '',
        description: '批量下载当前列表中的文件，一次下载量需小于20条',
        target: () => this.ref4.current,
        placement: 'left'
      },
      {
        title: '',
        description: '点击可收起/展开右侧关键词搜索模块',
        target: () => this.ref5.current,
        placement: 'left'
      },
    ];

    return (
      <div className={classes.root}>
         <div className={classes.topBar}>
          我的收藏
        </div>
        <div className={classes.main}>
          <div className={classes.leftTable}>
            <div className={['common-main-container', classes.tableOuter].join(' ')}>
              <div className={['main-top', classes.topTab].join(' ')}>
                <div>
                  {
                    this.state.showTab &&
                    this.state.tabList.map((v, i) => (
                      <span
                        key={i}
                        onClick={() => this.changeTab(v, i)}
                        className={[
                          "main-tab",
                          this.state.tabIndex == i ? "active" : "",
                        ].join(" ")}
                      >
                        {v.title}
                      </span>
                    ))
                  }
                </div>
                <div className={classes.slideIcon} style={{fontSize: 20, color: '#999'}} onClick={this.changeSearchShow}  ref={this.ref5}>
                  {
                    this.state.showSearch ? 
                    <Tooltip title="收起关键词搜索">
                      <MenuUnfoldOutlined />
                    </Tooltip>
                     :
                    <Tooltip title="展开关键词搜索">
                      <MenuFoldOutlined />
                    </Tooltip>
                  }
                </div>
              </div>
              <div  className={classes.container} id="tableContainer">
                <Table 
                  className={classes.tableContainer}
                  columns={this.state.columns} 
                  loading={this.state.loading} 
                  dataSource={this.state.data} 
                  onChange={this.handleChange} 
                  pagination={this.state.paginationObj}
                  scroll={{x: 1280}}
                  bordered
                />
                
              </div>
            </div>
          </div>
          <div className={[classes.rightForm, 'common-page', this.state.showSearch ? '' : classes.hideSearch].join(' ')}>
            
            <div className="common-left-search">
              <div className="left-search-title">
                <span className="search-title">关键词搜索</span>
                
              </div>
              <div className="search-form">
                <div className="form-item">
                  <div className="form-label">关键词</div>
                  <Input  value={this.state.form.keyword}
                    allowClear
                    onChange={(e) => this.onChangeForm(e.target.value, 'keyword')} 
                    placeholder="请输入关键词"/>
                </div>

                <div className={classes.labelContainer}>
                  <div className={classes.btnLine}>
                    <Button
                      variant="outlined"
                      onClick={this.showModal}
                      color="info"
                      ref={this.ref2}
                    >
                      管理收藏
                    </Button>
                    <Button
                      variant="outlined"
                      onClick={this.download}
                      color="info"
                      ref={this.ref3}
                    >
                      下载列表
                    </Button>
                    <Button
                      variant="outlined"
                      onClick={this.downloadFile}
                      color="info"
                      ref={this.ref4}
                    >
                      批量下载
                    </Button>
                  </div>
                  <Typography className={classes.subTitle}>
                    全部收藏关键词
                  </Typography>
                  {this.state.allLabelList.map((item) => {
                    return (
                      <span
                        onClick={() => this.changeLabel(item.lable_id)}
                        key={item.lable_content}
                        className={[
                          classes.tag,
                          this.state.labelArr == item.lable_id ? "active" : "",
                        ].join(" ")}
                      >
                        {item.lable_content}
                        {item.lable_id != "all"
                          ? `(${item.favorite_basefiles_count})`
                          : `(${this.state.fileTotal})`}
                      </span>
                    );
                  })}
                </div>
              </div>

              <div className="search-bottom-btns">
                <Button className="default-btn" onClick={this.resetForm}>重置</Button>
                <Button className="primary-btn" onClick={this.searchForm}>搜索</Button>
              </div>
            </div>
          </div>
        </div>

        <Modal
          open={this.state.openModal}
          onClose={this.handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div>
            <LabelModal
              width={520}
              title={this.state.modalTitle}
              close={this.handleClose}
              isEdit={this.state.isEdit}
              tagArr={this.state.tagList}
              handAdd={this.handAdd}
              handRemove={this.handRemove}
              dataId={this.state.dataId}
              recommendList={this.state.recommendList}
              parent_lable_id={this.state.favorite_parent_lable_id}
            />
          </div>
        </Modal>

        <Tour key={this.state.tourKey} current={this.state.tourCurrent} onChange={this.changeTour} open={this.state.openTour}  closeIcon={false}  indicatorsRender={() => (<></>)} onFinish={this.closeTour} steps={steps} />
      </div>
    );
  }
}

export default withStyles(styles)(withRouter(Collect));
